var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCotizacionTarjeta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.93,12.63,22,6h0l-.74-1.65a2.39,2.39,0,0,0-1.35-1.28,2.45,2.45,0,0,0-1.86,0l-15.72,7a2.44,2.44,0,0,0-1.23,3.22L1.81,15h0l3,6.62A2.43,2.43,0,0,0,8,22.87l15.72-7A2.42,2.42,0,0,0,25,14.5,2.47,2.47,0,0,0,24.93,12.63ZM2.19,12a1.15,1.15,0,0,1,.62-.66l15.72-7a1.15,1.15,0,0,1,.48-.1,1,1,0,0,1,.42.08,1.15,1.15,0,0,1,.66.62L20.58,6l-17.88,8-.49-1.08A1.15,1.15,0,0,1,2.19,12Zm21.62,2.1a1.15,1.15,0,0,1-.62.66l-15.72,7a1.13,1.13,0,0,1-.9,0,1.15,1.15,0,0,1-.66-.62l-2.7-6,17.88-8,2.7,6A1.15,1.15,0,0,1,23.81,14.05Z",
    fill: "#3b444e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.78,9.29,17.29,10.4a.62.62,0,0,0-.31.82.61.61,0,0,0,.57.37.56.56,0,0,0,.25-.05l2.49-1.11a.63.63,0,0,0,.31-.83A.62.62,0,0,0,19.78,9.29Z",
    fill: "#3b444e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.33,12.61l-6.62,3a.62.62,0,0,0-.31.82.61.61,0,0,0,.57.37.53.53,0,0,0,.25-.05l6.62-3a.62.62,0,0,0,.32-.82A.63.63,0,0,0,12.33,12.61Z",
    fill: "#3b444e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94,16.12l-2.49,1.1a.63.63,0,0,0-.31.83.62.62,0,0,0,.57.37A.57.57,0,0,0,7,18.36l2.48-1.1a.63.63,0,0,0,.32-.83A.61.61,0,0,0,8.94,16.12Z",
    fill: "#3b444e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCotizacionTarjeta);
export default __webpack_public_path__ + "static/media/ic_cotizacion_tarjeta.04ba124ab59fb541b5a1649ace3d47ff.svg";
export { ForwardRef as ReactComponent };